module.exports = __webpack_public_path__ + "static/temperamentscale-9279139b7a56d6e96f6124b41f4b8a65.png";